import React from 'react';
import sanerIcon from '../../../../assets/img/desktop/saner-logo.png';
import secpodLogo from '../../../../assets/img/desktop/secpod-logo.png';
import './CMGestionVulnerabilidades.css';

function CMGestionVulnerabilidades() {

    return (
        <main id="CMGestionVulnerabilidades">
            <section id="CMGV-c1">
                <h2>Gestión de Vulnerabilidades</h2>
                <ul>
                    <li>Inicio</li>
                    <li>/</li>
                    <li>Servicios</li>
                    <li>/</li>
                    <li>Ciberseguridad</li>
                    <li>/</li>
                    <li>Gestión de Vulnerabilidades</li>
                </ul>
            </section>
            <section id="CMGV-c2">
                <div id="CMGV-c2__text">
                    <h1>Gestión Continua de Vulnerabilidades y Exposición</h1>
                    <p>Detecte, defienda y derrote vulnerabilidades de principio a fin. Logre una reducción completa de la superficie de ataque con una gestión de riesgos inteligente, rápida y eficiente.</p>
                </div>
            </section>
            <section id="CMGV-c3">
                <div className="CMGV-service-card">
                    <div className="CMGV-service-card__icon">
                        <img src={sanerIcon} alt="Saner CVEM Icon" />
                    </div>
                    <h3>Saner CVEM</h3>
                    <p>Saner Continuous Vulnerability & Exposure Management (CVEM) es una plataforma unificada diseñada para empresas modernas que combate el creciente panorama de riesgos con capacidades avanzadas para escanear, evaluar, priorizar y remediar vulnerabilidades en dispositivos. La plataforma gestiona vulnerabilidades, exposiciones y otros riesgos de seguridad en una única consola unificada, utilizando un feed SCAP propio con más de 190,000 verificaciones de riesgo actualizadas diariamente.</p>
                    <div className="CMGV-service-card__features">
                        <h4>Características principales:</h4>
                        <ul>
                            <li>Base de datos con más de 190,000 verificaciones de seguridad</li>
                            <li>Gestión de parches automatizada</li>
                            <li>Priorización de riesgos basada en contexto empresarial</li>
                            <li>Cumplimiento normativo y gestión de configuración</li>
                            <li>Escaneo continuo y remediación integrada</li>
                            <li>Visibilidad completa de activos IT</li>
                            <li>Gestión de endpoints y endurecimiento</li>
                        </ul>
                    </div>
                    <div className="CMGV-service-card__logo">
                        <img src={secpodLogo} alt="SecPod Logo" />
                    </div>
                </div>
            </section>
        </main>
    );
}

export default CMGestionVulnerabilidades;

